import { render } from "./TheZoneManagement.vue?vue&type=template&id=b18b10e0&scoped=true"
import script from "./TheZoneManagement.vue?vue&type=script&lang=js"
export * from "./TheZoneManagement.vue?vue&type=script&lang=js"

import "./TheZoneManagement.vue?vue&type=style&index=0&id=b18b10e0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18b10e0"]])

export default __exports__